import { Skeleton } from "@mui/material";

interface Props {}

export default function OrderDetailsContentSkeletonUI(props: Props) {
	return (
		<div>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					gap: "10px",
					flexWrap: "wrap",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "5px",
						width: "50%",
					}}
				>
					<div>
						<Skeleton
							variant="rectangular"
							width={"30%"}
							height={20}
							sx={{ borderRadius: "4px" }}
						/>
					</div>

					<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
						<Skeleton
							variant="rectangular"
							width={"50%"}
							height={40}
							sx={{ borderRadius: "4px" }}
						/>
					</div>
				</div>
				<div
					style={{
						display: "flex",
						gap: "5px",
						justifyContent: "center",
						flexWrap: "wrap",
					}}
				>
					<Skeleton
						variant="rounded"
						width={128}
						height={44}
						sx={{ borderRadius: "30px" }}
					></Skeleton>

					<Skeleton
						variant="rounded"
						width={128}
						height={44}
						sx={{ borderRadius: "30px" }}
					></Skeleton>
				</div>
			</div>
			<div className="order-details-card-row">
				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={300}
					sx={{ borderRadius: "14px" }}
				/>
				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={300}
					sx={{ borderRadius: "14px" }}
				/>
			</div>

			<div className="order-details-body">
				<div>
					<Skeleton
						variant="rectangular"
						width={"100%"}
						height={90}
						sx={{ borderRadius: "14px", margin: "20px 0px" }}
					/>
					<Skeleton
						variant="rectangular"
						width={"100%"}
						height={90}
						sx={{ borderRadius: "14px", margin: "20px 0px" }}
					/>
				</div>
				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={200}
					sx={{ borderRadius: "14px", margin: "20px 0px" }}
				/>
			</div>
		</div>
	);
}
